// 共享工具：封装聊天历史相关 API（供 BeflamChat 和 AssistantForm 共用）
export async function chatHistoryRequest(
  sGlobal: any,
  body: Record<string, any>
): Promise<any | null> {
  const host = sGlobal?.config?.host ?? '';
  const res = await fetch(`${host}/api/agent/chathistory`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) return null;
  return res.json();
}

export async function downloadChatExport(
  sGlobal: any,
  conversationId: string
): Promise<Response> {
  const host = sGlobal?.config?.host ?? '';
  return fetch(`${host}/api/agent/chatexport/${conversationId}`, {
    method: 'GET',
    headers: { Authorization: `Bearer ${sGlobal.session.id}` },
  });
}
